import React, {useState} from 'react';
import {Input} from "@mui/material";
import PrevAndNextComponent from "../components/PrevAndNextComponent";
import TextQuestionWithIcon from "../components/TextQuestionWithIcon";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";

const Situation = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {
    const [inputValue, setInputValue] = useState(step.summary);

    // Event handler to update the input value
    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleLocalNext = () => {
        handleSetStepSummary({...step, summary: inputValue});
        handleNext();
    };

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left", fontSize: "24px"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>
            <br/>
            <TextQuestionWithIcon
                text="What's a recent situation that led to this negative thought?"
                icon={<ArrowCircleRightOutlinedIcon />}
                subtitle={<>For example, if your negative thought is <em>"No one cares about me"</em>, the situation might be <em>"My friend never texted me back."</em></>}
            />
            <br/>
            <Input placeholder="Enter your thought here" value={inputValue} onChange={handleChange}></Input>
            <br/>

            <PrevAndNextComponent steps={steps} activeStep={activeStep} handleBack={handleBack} handleLocalNext={handleLocalNext} />
        </div>
    );
};

export default Situation;